import { createAsyncThunk } from '@reduxjs/toolkit';
import focusSkuApi from '../../../../services/apiService/api/focusSkuApi';

export const fetchFocusSkuThunk = createAsyncThunk(
  'focusSku/fetch',
  async ({ page = 0, size = 20, category = '' } = {}, { rejectWithValue }) => {
    try {
      const response = await focusSkuApi.fetchFocusSku({ page, size, category });
      response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      return response.data.data; // Adjust as per your API response
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
